// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SignOut-module-text-29j-v{margin-inline-end:12px}.SignOut-module-wrap-13lwy{cursor:pointer;background-color:rgba(0,0,0,0);display:flex;align-items:center;box-sizing:border-box;height:61px;width:100%;border:0;justify-content:center;color:#3567ff;color:var(--colors-accent-accent-100, #3567ff)}@media(min-width: 960px){.SignOut-module-wrap-13lwy{border:1px solid rgba(150,150,150,.47);border-radius:8px;padding:22px;justify-content:initial;color:inherit}}.SignOut-module-wrap-13lwy:hover path{fill:#3567ff;fill:var(--colors-accent-accent-100, #3567ff)}.SignOut-module-button-2Iopo{width:100%}", ""]);
// Exports
exports.locals = {
	"text": "SignOut-module-text-29j-v",
	"wrap": "SignOut-module-wrap-13lwy",
	"button": "SignOut-module-button-2Iopo"
};
module.exports = exports;
